export default "__VITE_ASSET__1c79bef0__"